module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.level == 20) ? _c('div', _vm._l((_vm.content), function(item) {
    return _c('div', [(item.show_type == _vm.CONTENT_TYPE_NORMAL && item.arr) ? [_c('all-render', {
      attrs: {
        "contentId": item.arr[0].content_id,
        "dealId": item.arr[0].deal_id,
        "dataId": item.arr[0].dataId,
        "query": item.arr[0].query,
        "iden": item.arr[0].iden,
        "showType": item.arr[0].show_type,
        "level": _vm.level
      },
      on: {
        "setFilterQuery": _vm.setFilterQuery,
        "sendParams": _vm.sendParams,
        "saveCallback": _vm.saveCallback
      }
    })] : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (item.show_type == _vm.CONTENT_TYPE_TAB && item.arr) ? [_c('el-tabs', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.activeName),
        expression: "item.activeName"
      }],
      domProps: {
        "value": (item.activeName)
      },
      on: {
        "tab-click": function($event) {
          _vm.handleClick(item)
        },
        "input": function($event) {
          item.activeName = $event
        }
      }
    }, _vm._l((item.arr), function(tab) {
      return _c('el-tab-pane', {
        attrs: {
          "label": tab.name,
          "name": tab.name
        }
      }, [(tab.rendered) ? _c('div', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.loading),
          expression: "loading"
        }],
        staticStyle: {
          "min-height": "100px"
        }
      }, [_c('all-render', {
        attrs: {
          "contentId": tab.content_id,
          "dealId": tab.deal_id,
          "dataId": tab.dataId,
          "query": tab.query,
          "iden": tab.iden,
          "showType": tab.show_type,
          "level": _vm.level
        },
        on: {
          "setFilterQuery": _vm.setFilterQuery,
          "sendParams": _vm.sendParams,
          "saveCallback": _vm.saveCallback
        }
      })]) : _vm._e()])
    }))] : _vm._e(), _vm._v(" ")], true)
  })) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.level == 10) ? _c('div', [_c('all-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId,
      "dataId": _vm.dataId,
      "query": _vm.query,
      "iden": _vm.iden,
      "showType": _vm.showType
    },
    on: {
      "setFilterQuery": _vm.setFilterQuery,
      "sendParams": _vm.sendParams,
      "saveCallback": _vm.saveCallback
    }
  })]) : _vm._e(), _vm._v(" "), _vm._v(" "), (_vm.level == 20) ? _c('div', {
    staticClass: "m-t-20",
    staticStyle: {
      "display": "inline-block"
    }
  }, [(!_vm.isDialog) ? _c('el-button', {
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-adc767f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/render.vue
// module id = 1973
// module chunks = 2